import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';
import { arrayBufferToBase64, sanitizeZplForLabelary } from '~/store/zpl/utils';

export const printers = {
  getLabel: {
    queryKey: 'labelary-service/printers/label',
    configurationType: 'no-cache' as const,
    fn: async (editorBuffer: string, labelaryParams: { dpmm: string; width: number; height: number }) => {
      const dimensions = `${labelaryParams.width}x${labelaryParams.height}`;

      const response = await GatewayAxiosClient.post<ArrayBuffer>(
        `/labelary/v1/printers/${labelaryParams.dpmm}/labels/${dimensions}/0/`,
        { zpl: sanitizeZplForLabelary(editorBuffer) },
        { responseType: 'arraybuffer' },
      );

      return `data:${response.headers['content-type']};base64,${arrayBufferToBase64(response.data)}`;
    },
  },
};
